import Vue from 'vue'
import App from './App.vue'
import {BootstrapVue, IconsPlugin} from "bootstrap-vue";

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/css/main.css'
import {MetadataBackup} from "@/assets/ts/MetadataBackup";
import {Utils} from "@/assets/ts/Utils";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.config.productionTip = false

if (!Utils.GetCookie("apiKey"))
    Utils.SetCookie("apiKey", "AIzaSyAM-4H2e4wQw2e8VHfz3TeodwE2Xh9J66o");

// no trailing slashes, must contain scheme
MetadataBackup.EndPointDomain = "http://api.backup.goodbeststudy.tech";

new Vue({
  render: h => h(App),
}).$mount('#app')
